import React, { Component } from "react";
import tool_icon from "../assets/img/app.svg";
import qricon from "../assets/img/qr-code.svg";
import iosicon from "../assets/img/ios.svg";
import windosicon from "../assets/img/windows.svg";
import androidicon from "../assets/img/android.svg";
import requirementicon from "../assets/img/open-new.svg";
import webicon from "../assets/img/web.svg";
import Modal from "react-modal";
import Loading from "../Loading/Loading";
import ReactGA from "react-ga";
var parser = require("fast-xml-parser");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0",
    maxWidth: "650px",
    width: "100%",
    maxHeight: "100%",
  },
};

class InstallPage extends Component {
  constructor(props) {
    super(props);
    // const lang = new URLSearchParams(props.location.search).get("lang");
    // console.log(props.match.params.filter, props.location.search);
    this.state = {
      filterParams: new URLSearchParams(props.location.search),
      bookSeriesArray: null,
      subjectsList: null,
      toolsList: null,
      SubjectMenuOpenState: [],
      SubjectSelectedState: [],
      selectedBookSeriesState: [],

      loadDone: false,
      requirementModalIsOpen: false,
      qrcode: false,
      item: null,
      init: false,

      footerYear: new Date().getFullYear(),
    };
  }

  componentDidMount() {
    if (this.state.filterParams.get("lang") != null) {
      this.props.changeLanguage(this.state.filterParams.get("lang"));
    }
    if (this.state.filterParams.get("filter") == null) {
      this.props.history.push("/p?filter=all");
      return window.location.reload();
    }

    this.loadXMLFile();
  }

  selectAll = (action) => {
    var newSubjectSelectedState = [];
    var newselectedBookSeriesState = [];
    if (action == "selectAll") {
      var { bookSeriesArray, subjectsList } = this.state;
      subjectsList.map((item) => {
        newSubjectSelectedState.push(item.subjectId);
      });
      bookSeriesArray.map((item) => {
        newselectedBookSeriesState.push(item.shortName);
        console.log(this[`${item.subject}`].checked);
      });

      newSubjectSelectedState.map((item) => {
        this[`${item}`].indeterminate = false;
      });

      console.log(newselectedBookSeriesState, newSubjectSelectedState);
      this.setState({
        selectedBookSeriesState: newselectedBookSeriesState,
        SubjectSelectedState: newSubjectSelectedState,
      });
      this.props.history.push("/p?fliter=all");
    } else {
      this.props.history.push("/p?fliter=n");
    }

    this.setState({
      SubjectSelectedState: newSubjectSelectedState,
      selectedBookSeriesState: newselectedBookSeriesState,
    });
  };

  openModal = (type, item) => {
    console.log(item);
    switch (type) {
      case "requirement":
        ReactGA.event({
          category: "Installation page",
          action: "Click requriement",
          label:
            "App:" +
            item.ToolName.en.replace("@", " ") +
            ", Book Series:[" +
            item.bookSeries.join("|") +
            "], Subject:[" +
            item.subject.join("|") +
            "]",
        });
        this.setState({ requirementModalIsOpen: true, item: item });
        break;
      case "qrcode":
        this.setState({ qrcodeModalIsOpen: true, item: item });
        break;
    }
  };

  afterOpenModal = () => {};

  closeModal = (type) => {
    switch (type) {
      case "requirement":
        this.setState({ requirementModalIsOpen: false });
        break;
      case "qrcode":
        this.setState({ qrcodeModalIsOpen: false });
        break;
    }
  };

  openSubmenu = (subject) => {
    var { SubjectMenuOpenState } = this.state;
    var newSubjectMenuOpenState = SubjectMenuOpenState;
    if (SubjectMenuOpenState.indexOf(subject) != -1) {
      // console.log(SubjectMenuOpenState.indexOf(subject));
      newSubjectMenuOpenState.splice(SubjectMenuOpenState.indexOf(subject), 1);
      // console.log(newSubjectMenuOpenState);
      this.setState({
        SubjectMenuOpenState: newSubjectMenuOpenState,
      });
    } else {
      //console.log(subject);
      this.setState({
        SubjectMenuOpenState: [...SubjectMenuOpenState, subject],
      });
    }
  };

  preSetData = (xmlData, matchUrl) => {
    //console.log("Start pre set!", xmlData);
    //Get All subject from xml
    var xmlSubjectsList = [];
    var subjectsList = [];

    if (Array.isArray(xmlData.Workbook.Worksheet[2].Table.Row) == true) {
      /*
      console.log(
        "Read xml column: " +
          xmlData.Workbook.Worksheet[2].Table.Row[0].Cell.length
      );
      */
      xmlData.Workbook.Worksheet[2].Table.Row.map((row, index) => {
        var temp = [];
        for (
          var i = 0;
          i < xmlData.Workbook.Worksheet[2].Table.Row[0].Cell.length;
          i++
        ) {
          xmlData.Workbook.Worksheet[2].Table.Row[index].Cell[i] != "-"
            ? temp.push(
                xmlData.Workbook.Worksheet[2].Table.Row[index].Cell[i].Data
              )
            : temp.push("");
        }
        xmlSubjectsList.push(temp);
      });
      //console.log(xmlSubjectsList);

      //get index by check the title
      var chineseSubjectIndex = xmlSubjectsList[0].indexOf(
        "chinese subject name"
      );
      var englishSubjectIndex = xmlSubjectsList[0].indexOf(
        "english subject name"
      );
      //reset subject from xml
      xmlSubjectsList.map((item, index) => {
        index != 0 &&
          subjectsList.push({
            subjectId: item[0],
            chineseSubjectName: item[chineseSubjectIndex],
            englishSubjectName: item[englishSubjectIndex],
          });
      });
      //console.log(subjectsList);
    }

    //Get Tools Data
    var xmlToolsList = [];
    var ToolsList = [];

    if (Array.isArray(xmlData.Workbook.Worksheet[0].Table.Row) == true) {
      /*
      console.log(
        "Read xml column: " +
          xmlData.Workbook.Worksheet[0].Table.Row[0].Cell.length
      );
      */
      xmlData.Workbook.Worksheet[0].Table.Row.map((row, index) => {
        var temp = [];
        for (
          var i = 0;
          i < xmlData.Workbook.Worksheet[0].Table.Row[0].Cell.length;
          i++
        ) {
          xmlData.Workbook.Worksheet[0].Table.Row[index].Cell[i] != "-"
            ? temp.push(
                xmlData.Workbook.Worksheet[0].Table.Row[index].Cell[i].Data
              )
            : temp.push("");
        }
        xmlToolsList.push(temp);
      });
      console.log(xmlToolsList);

      //Get title index
      var Subject = xmlToolsList[0].indexOf("Subjects");
      var bookSeries = xmlToolsList[0].indexOf("book series");
      var toolChinesenameIndex = xmlToolsList[0].indexOf("Tool Chinese Name");
      var toolEnglishnameIndex = xmlToolsList[0].indexOf("Tool English Name");
      var toolIconIndex = xmlToolsList[0].indexOf("Tool Icon File Name");

      var DecChineseURLIndex = xmlToolsList[0].indexOf("Chinese Description");
      var DecEnglishURLIndex = xmlToolsList[0].indexOf("English Description");

      var WebChineseURLIndex = xmlToolsList[0].indexOf("Chinese Web");
      var WebEnglishURLIndex = xmlToolsList[0].indexOf("English Web");
      var toolWebQRPath = xmlToolsList[0].indexOf("Web QR Code");

      var iOSChineseURLIndex = xmlToolsList[0].indexOf("iOS App Chinese URL");
      var iOSEnglishURLIndex = xmlToolsList[0].indexOf("iOS App English URL");
      var toolIosQRPath = xmlToolsList[0].indexOf("iOS QR Code");

      var pcChineseURLIndex = xmlToolsList[0].indexOf("PC Chinese URL");
      var pcEnglishURLIndex = xmlToolsList[0].indexOf("PC English URL");

      var AndroidChineseURLIndex = xmlToolsList[0].indexOf(
        "Android App Chinese URL"
      );
      var AndroidEnglishURLIndex = xmlToolsList[0].indexOf(
        "Android App English URL"
      );
      var toolAndroidQRPath = xmlToolsList[0].indexOf("Android QR Code");
      xmlToolsList.map((item, index) => {
        index != 0 &&
          ToolsList.push({
            toolId: item[0],
            toolDescription: {
              en: item[DecEnglishURLIndex].replace("&amp;", "&"),
              zh: item[DecChineseURLIndex].replace("&amp;", "&"),
            },
            ToolName: {
              en: item[toolEnglishnameIndex].replace("&amp;", "&"),
              zh: item[toolChinesenameIndex].replace("&amp;", "&"),
            },
            toolIconPath: "./assets/images/" + item[toolIconIndex],
            pc: {
              chineseURL:
                item[pcChineseURLIndex] != "-"
                  ? item[pcChineseURLIndex].replace("&amp;", "&")
                  : "",
              englishURL:
                item[pcEnglishURLIndex] != "-"
                  ? item[pcEnglishURLIndex].replace("&amp;", "&")
                  : "",
            },
            web: {
              chineseURL:
                item[WebChineseURLIndex] != "-"
                  ? item[WebChineseURLIndex].replace("&amp;", "&")
                  : "",
              englishURL:
                item[WebEnglishURLIndex] != "-"
                  ? item[WebEnglishURLIndex].replace("&amp;", "&")
                  : "",
              toolWebQRPath:
                item[toolWebQRPath] != "-"
                  ? "./assets/images/" + item[toolWebQRPath]
                  : "",
            },
            iosApp: {
              chineseURL:
                item[iOSChineseURLIndex] != "-"
                  ? item[iOSChineseURLIndex].replace("&amp;", "&")
                  : "",
              englishURL:
                item[iOSEnglishURLIndex] != "-"
                  ? item[iOSEnglishURLIndex].replace("&amp;", "&")
                  : "",
              toolIosQRPath:
                item[toolIosQRPath] != "-"
                  ? "./assets/images/" + item[toolIosQRPath]
                  : "",
            },
            androidApp: {
              chineseURL:
                item[AndroidChineseURLIndex] != "-"
                  ? item[AndroidChineseURLIndex].replace("&amp;", "&")
                  : "",
              englishURL:
                item[AndroidEnglishURLIndex] != "-"
                  ? item[AndroidEnglishURLIndex].replace("&amp;", "&")
                  : "",
              toolAndroidQRPath:
                item[toolAndroidQRPath] != "-"
                  ? "./assets/images/" + item[toolAndroidQRPath]
                  : "",
            },
            subject: item[Subject].split(","),
            bookSeries: item[bookSeries].split(","),
          });
      });
      //console.log(ToolsList);
    }

    // get tools descript
    var xmlToolsDescriptionList = [];
    var ToolsDescriptionList = [];
    if (Array.isArray(xmlData.Workbook.Worksheet[1].Table.Row) == true) {
      /*
      console.log(
        "Read xml column: " +
          xmlData.Workbook.Worksheet[1].Table.Row[0].Cell.length
      );
      */
      xmlData.Workbook.Worksheet[1].Table.Row.map((row, index) => {
        var temp = [];
        for (
          var i = 0;
          i < xmlData.Workbook.Worksheet[1].Table.Row[0].Cell.length;
          i++
        ) {
          xmlData.Workbook.Worksheet[1].Table.Row[index].Cell[i] != "-"
            ? temp.push(
                xmlData.Workbook.Worksheet[1].Table.Row[index].Cell[i].Data
              )
            : temp.push("");
        }
        xmlToolsDescriptionList.push(temp);
      });
      //console.log(xmlToolsDescriptionList);

      //reset discript data
      var webChineseDes = xmlToolsDescriptionList[0].indexOf(
        "Web Chinese Description"
      );
      var iosChineseDes = xmlToolsDescriptionList[0].indexOf(
        "iOS Chinese Description"
      );
      var androidChineseDes = xmlToolsDescriptionList[0].indexOf(
        "Android Chinese Description"
      );
      var webEnglishDes = xmlToolsDescriptionList[0].indexOf(
        "Web English Description"
      );
      var iosEnglishDes = xmlToolsDescriptionList[0].indexOf(
        "iOS English Description"
      );
      var androidEnglishDes = xmlToolsDescriptionList[0].indexOf(
        "Android English Description"
      );
      var PCChineseDes = xmlToolsDescriptionList[0].indexOf(
        "PC Chinese Description"
      );
      var PCEnglishDes = xmlToolsDescriptionList[0].indexOf(
        "PC English Description"
      );
      //console.log(PCChineseDes, PCEnglishDes);
      ToolsList.map((item, index) => {
        xmlToolsDescriptionList.map((row, rindex) => {
          if (rindex != 0)
            if (item.toolId == row[0]) {
              ToolsList[index].description = {
                webChineseDes:
                  row[webChineseDes] != "-"
                    ? row[webChineseDes].split("|=|")
                    : [],
                webEnglishDes:
                  row[webEnglishDes] != "-"
                    ? row[webEnglishDes].split("|=|")
                    : [],
                iosChineseDes:
                  row[iosChineseDes] != "-"
                    ? row[iosChineseDes].split("|=|")
                    : [],
                iosEnglishDes:
                  row[iosEnglishDes] != "-"
                    ? row[iosEnglishDes].split("|=|")
                    : [],
                androidChineseDes:
                  row[androidChineseDes] != "-"
                    ? row[androidChineseDes].split("|=|")
                    : [],
                androidEnglishDes:
                  row[androidEnglishDes] != "-"
                    ? row[androidEnglishDes].split("|=|")
                    : [],
                pcChineseDes:
                  row[PCChineseDes] != "-"
                    ? row[PCChineseDes].split("|=|")
                    : [],
                pcEnglishDes:
                  row[PCEnglishDes] != "-"
                    ? row[PCEnglishDes].split("|=|")
                    : [],
              };
            }
        });
      });
      //console.log("Final tools list:", ToolsList);
    }
    if (matchUrl) {
      var selectedBookSeriesList = [];
      var { bookSeriesArray } = this.state;
      var findSubject = "";
      var count = 0;
      bookSeriesArray.map((item) => {
        if (item.shortName == this.state.filterParams.get("filter")) {
          selectedBookSeriesList.push(item.shortName);
          findSubject = item.subject;
        }
      });
      bookSeriesArray.map((item) => {
        if (findSubject == item.subject) {
          count = count + 1;
        }
      });
      if (count > 1) {
        this.setState({
          SubjectMenuOpenState: [findSubject],
          selectedBookSeriesState: selectedBookSeriesList,
          subjectsList: subjectsList,
          toolsList: ToolsList,
          loadDone: true,
        });
      } else {
        this.setState({
          selectedBookSeriesState: selectedBookSeriesList,
          SubjectSelectedState: [
            ...this.state.SubjectSelectedState,
            findSubject,
          ],
          subjectsList: subjectsList,
          toolsList: ToolsList,
          loadDone: true,
        });
      }

      /*
      this.setState({
        selectedBookSeriesState:,
        SubjectSelectedState:,
        subjectsList: subjectsList,
        toolsList: ToolsList,
        loadDone: true
      });
      */
    } else {
      if (this.state.filterParams.get("filter") != "n") {
        var { bookSeriesArray } = this.state;
        var selectAllSubject = [];
        var selectAllBookSeries = [];
        subjectsList.map((item) => {
          selectAllSubject.push(item.subjectId);
        });
        bookSeriesArray.map((item) => {
          selectAllBookSeries.push(item.shortName);
        });
        this.setState({
          selectedBookSeriesState: selectAllBookSeries,
          SubjectSelectedState: selectAllSubject,
          subjectsList: subjectsList,
          toolsList: ToolsList,
          loadDone: true,
        });
      } else {
        this.setState({
          subjectsList: subjectsList,
          toolsList: ToolsList,
          loadDone: true,
        });
      }
    }
    console.table(ToolsList);
  };

  loadXMLFile = () => {
    var usefulToolsList = [];
    fetch("./assets/storeage/installation_page_data.xml", {
      mode: "no-cors",
      method: "GET",
      headers: new Headers({
        Accept: "application/xml",
        "content-type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, PUT",
        "Access-Control-Allow-Headers": "Content-Type",
      }),
    }).then((response) => {
      response
        .text()
        .then((text) => parser.getTraversalObj(text))
        .then((xmlText) => {
          var xmlBookSeriesList = [];
          console.log(jsonObj);
          var jsonObj = parser.convertToJson(xmlText, { arrayMode: false });
          console.log(jsonObj);
          if (jsonObj.Workbook.Worksheet.length == 4) {
            if (
              Array.isArray(jsonObj.Workbook.Worksheet[3].Table.Row) == true
            ) {
              /*
              console.log(
                "Read xml column: " +
                  jsonObj.Workbook.Worksheet[3].Table.Row[0].Cell.length
              );
              */
              jsonObj.Workbook.Worksheet[3].Table.Row.map((row, index) => {
                var temp = [];
                for (
                  var i = 0;
                  i < jsonObj.Workbook.Worksheet[3].Table.Row[0].Cell.length;
                  i++
                ) {
                  jsonObj.Workbook.Worksheet[3].Table.Row[index].Cell[i] != "-"
                    ? temp.push(
                        jsonObj.Workbook.Worksheet[3].Table.Row[index].Cell[i]
                          .Data
                      )
                    : temp.push("");
                }
                xmlBookSeriesList.push(temp);
              });
              //console.log(xmlBookSeriesList);
              var bookSeriesArray = [];
              //Get colunm by title
              var subject = xmlBookSeriesList[0].indexOf("subject id");
              var cBSName = xmlBookSeriesList[0].indexOf(
                "chinese book series name"
              );
              var eBSName = xmlBookSeriesList[0].indexOf(
                "english book series name"
              );
              var sBSName = xmlBookSeriesList[0].indexOf("short name");
              xmlBookSeriesList.map((item, index) => {
                if (index != 0) {
                  bookSeriesArray.push({
                    subject: item[subject],
                    chineseBookSeriesName: item[cBSName].replace("&amp;", "&"),
                    englishBookSeriesName: item[eBSName].replace("&amp;", "&"),
                    shortName: item[sBSName],
                  });
                }
              });
              //console.log(bookSeriesArray);
              this.setState({
                bookSeriesArray: bookSeriesArray,
              });
              //Check URL params
              //if url != /all
              if (
                this.state.filterParams.get("filter") != "all" &&
                this.state.filterParams.get("filter") != "n"
              ) {
                var match = false;
                var i = 0;
                var urlFilter = null;
                do {
                  if (
                    bookSeriesArray[i].shortName ==
                    this.state.filterParams.get("filter")
                  ) {
                    match = true;
                    urlFilter = this.state.filterParams.get("filter");
                    console.log(bookSeriesArray[i].shortName, i, match);
                    console.log("URL find match");
                  }
                  console.log(i);
                  i = i + 1;
                } while (match != true && i < parseInt(bookSeriesArray.length));
                //if match
                if (match) {
                  console.log("URL match");
                  this.preSetData(jsonObj, true);
                } else {
                  // no match
                  //push to all
                  console.log("URL not match");
                  this.props.history.push("/all");
                  window.location.reload();
                }
              }
              //url == all
              else {
                this.preSetData(jsonObj, false);
              }
            } else {
              console.log(
                "Error: XML file book series sheet some data missing."
              );
            }
          } else {
            console.log(
              "Error: XML file sheet missing. should have 4 Sheets in xml file."
            );
          }
        });
    });
  };

  subMenuHandle = (item) => {
    var open = false;
    var { SubjectMenuOpenState } = this.state;
    if (SubjectMenuOpenState.indexOf(item.subjectId) != -1) {
      open = true;
    } else {
      open = false;
    }

    return open ? "sub-menu open" : "sub-menu";
  };

  countbookSeriesUnderSubject = (item) => {
    var count = 0;
    var { bookSeriesArray } = this.state;
    bookSeriesArray.map((bookSeries, sindex) => {
      if (bookSeries.subject == item.subjectId) {
        count = count + 1;
      }
    });
    return count;
  };

  onChangeSubjectCheckBox = (e, item) => {
    //console.log(e.target.checked, this[`${item.subjectId}`].indeterminate);
    if (e.target.checked && !e.indeterminate) {
      this[`${item.subjectId}`].indeterminate = false;
      //console.log("999", this[`${item.subjectId}`].indeterminate);
    }
    var open = false;

    var { SubjectSelectedState, bookSeriesArray, selectedBookSeriesState } =
      this.state;
    //console.log(e.target.checked, item);
    if (e.target.checked) {
      ReactGA.event({
        category: "Installation page",
        action: "Click filter subject",
        label: "Subject:" + item.subjectId,
      });
      var selectBookSeries = [];
      bookSeriesArray.map((bitem) => {
        if (item.subjectId == bitem.subject) {
          selectBookSeries.push(bitem.shortName);
        }
      });
      var newSelectedBookSeries =
        selectedBookSeriesState.concat(selectBookSeries);

      var newSubjectSelectedState = SubjectSelectedState.concat(item.subjectId);

      //console.log(newSelectedBookSeries, newSubjectSelectedState);

      newSelectedBookSeries = newSelectedBookSeries.filter(this.onlyUnique);
      this.setState({
        SubjectSelectedState: newSubjectSelectedState,
        selectedBookSeriesState: newSelectedBookSeries,
      });
    } else {
      var newSubjectSelectedState = SubjectSelectedState;
      var selectBookSeries = [];
      SubjectSelectedState.splice(
        SubjectSelectedState.indexOf(item.subjectId),
        1
      );

      bookSeriesArray.map((bsitem) => {
        selectedBookSeriesState.map((sbs) => {
          if (sbs == bsitem.shortName) {
            if (bsitem.subject != item.subjectId) {
              selectBookSeries.push(bsitem.shortName);
            }
          }
        });
      });
      selectBookSeries = selectBookSeries.filter(this.onlyUnique);
      //console.log(newSubjectSelectedState, selectBookSeries);
      /*
      newSubjectSelectedState.splice(
        newSubjectSelectedState.indexOf(item.subjectId),
        1
      );
      */
      this.setState({
        SubjectSelectedState: newSubjectSelectedState,
        selectedBookSeriesState: selectBookSeries,
      });
    }
  };

  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  onChangeBookSeriesCheckBox = (e, BookSeriesitem) => {
    var {
      selectedBookSeriesState,
      subjectsList,
      SubjectSelectedState,
      bookSeriesArray,
    } = this.state;
    if (e.target.checked) {
      ReactGA.event({
        category: "Installation page",
        action: "Click filter book series",
        label:
          "Book Series:" +
          BookSeriesitem.shortName +
          ", Subject:" +
          BookSeriesitem.subject,
      });
      var newSubjectSelectedState = SubjectSelectedState;
      var newselectedBookSeriesState = selectedBookSeriesState;
      newselectedBookSeriesState.push(BookSeriesitem.shortName);

      var bookSeriesUnderSubjectTotalCount = () => {
        var Scount = 0;

        bookSeriesArray.map((obj) => {
          //console.log(obj, BookSeriesitem.subject);
          if (obj.subject == BookSeriesitem.subject) {
            Scount = Scount + 1;
          }
        });
        return Scount;
      };

      if (bookSeriesUnderSubjectTotalCount() == 1) {
        newSubjectSelectedState.push(BookSeriesitem.subject);
      }

      this.setState({
        selectedBookSeriesState: newselectedBookSeriesState,
        SubjectSelectedState: newSubjectSelectedState,
      });
      /*
      console.log(
        subjectsList,
        bookSeriesUnderSubjectTotalCount(),
        BookSeriesitem,
        newselectedBookSeriesState,
        SubjectSelectedState,
        newSubjectSelectedState
      );
      */
    } else {
      var newSubjectSelectedState = SubjectSelectedState;
      var newselectedBookSeriesState = selectedBookSeriesState;

      newSubjectSelectedState.splice(
        newSubjectSelectedState.indexOf(BookSeriesitem.subject),
        1
      );

      newselectedBookSeriesState.splice(
        selectedBookSeriesState.indexOf(BookSeriesitem.shortName),
        1
      );
      newselectedBookSeriesState = newselectedBookSeriesState.filter(
        this.onlyUnique
      );
      //console.log(newSubjectSelectedState, newselectedBookSeriesState);
      /*
      var newSubjectSelectedState = SubjectSelectedState;
      var newselectedBookSeriesState = selectedBookSeriesState;
      console.log(newselectedBookSeriesState,
        selectedBookSeriesState.indexOf(BookSeriesitem.englishBookSeriesName)
      );
      newselectedBookSeriesState.splice(
        selectedBookSeriesState.indexOf(BookSeriesitem.englishBookSeriesName),
        1
      );
      console.log(SubjectSelectedState.indexOf(BookSeriesitem.subject));
      newSubjectSelectedState.splice(
        SubjectSelectedState.indexOf(BookSeriesitem.subject),
        1
      );
      console.log(newselectedBookSeriesState, newSubjectSelectedState);
      this.setState({
        selectedBookSeriesState: newselectedBookSeriesState,
        SubjectSelectedState: newSubjectSelectedState
      });*/
      this.setState({
        selectedBookSeriesState: newselectedBookSeriesState,
        SubjectSelectedState: newSubjectSelectedState,
      });
    }
  };

  isAllBookSeriesSelectedUnderSubject = (e, item, check) => {
    if (check == "after" && this.state.init != true) {
      this.setState({
        init: true,
      });
    }
    if (check == "before") {
      var { selectedBookSeriesState, SubjectSelectedState, bookSeriesArray } =
        this.state;
      var bookSeriesUnderSubjectTotalCount =
        this.countbookSeriesUnderSubject(item);
      var count = 0;
      selectedBookSeriesState.map((bitem, index) => {
        bookSeriesArray.map((obj) => {
          if (obj.shortName == bitem) {
            if (obj.subject == item.subjectId) {
              count = count + 1;
            }
          }
        });
      });
      if (count == bookSeriesUnderSubjectTotalCount) {
        var checkbox = this[`${e}`];
        if (checkbox != null) checkbox.indeterminate = false;
        console.log(item.subjectId, "true");
        return true;
      } else {
        if (count != 0) {
          var checkbox = this[`${e}`];
          if (checkbox != null) checkbox.indeterminate = true;
        } else {
          var checkbox = this[`${e}`];
          if (checkbox != null) checkbox.indeterminate = false;
        }
        // console.log("FASLALSALS");
        console.log(item.subjectId, "false");
        return false;
        //
      }
    }
  };

  render() {
    //console.log(this.props.match.params.filter);
    const {
      subjectsList,
      bookSeriesArray,
      SubjectMenuOpenState,
      SubjectSelectedState,
      toolsList,
      selectedBookSeriesState,

      loadDone,
      item,
      footerYear,
    } = this.state;
    const lang = localStorage.getItem("i18nextLng");
    const { t, changeLanguage } = this.props;

    if (loadDone) {
      return (
        <div className="wrapper">
          <div className="container">
            <div className="main-header">
              <nav
                id="main"
                className="navbar navbar-expand fixed-top class-nav-bar md-whiteframe-4dp"
              >
                <div className="be-navbar-header class-nb-exit">
                  <span className="navbar-brand" href="" />
                </div>
                <div className="class-nb-title" />
                <div className="class-nb-buttons">
                  <div
                    className="nav navbar-nav float-right be-user-nav"
                    id="be-navbar-collapse"
                  >
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        {lang == "en-US" ? (
                          <a
                            style={{ display: "flex" }}
                            onClick={() => changeLanguage("zh-HK")}
                          >
                            <i className="material-icons">language</i>
                            <button
                              type="button"
                              className="link-button nav-link"
                            >
                              中文
                            </button>
                          </a>
                        ) : (
                          <a
                            style={{ display: "flex" }}
                            onClick={() => changeLanguage("en-US")}
                          >
                            <i className="material-icons">language</i>
                            <button
                              type="button"
                              className="link-button nav-link"
                            >
                              English
                            </button>
                          </a>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
            <div className="content site-wrapper">
              <div
                id="m"
                className="main-content container-fluid dashboard-body"
              >
                <div className="body_row">
                  <div
                    className={
                      SubjectMenuOpenState.indexOf("MobileMenu") != -1
                        ? "filter-card open"
                        : "filter-card"
                    }
                  >
                    <div className="header">
                      <div className="text">
                        <i className="material-icons">filter_list</i>
                        {t("Fliter your tools")}
                        {SubjectMenuOpenState.indexOf("MobileMenu") == -1 ? (
                          <i
                            className="material-icons"
                            onClick={() => this.openSubmenu("MobileMenu")}
                          >
                            keyboard_arrow_right
                          </i>
                        ) : (
                          <i
                            className="material-icons"
                            onClick={() => this.openSubmenu("MobileMenu")}
                          >
                            keyboard_arrow_down
                          </i>
                        )}
                      </div>
                    </div>
                    <div
                      className={
                        SubjectMenuOpenState.indexOf("MobileMenu") != -1
                          ? "sub-header mobile open"
                          : "sub-header mobile"
                      }
                    >
                      <div className="row">
                        <div
                          className="left"
                          onClick={() => {
                            this.selectAll("selectAll");
                            ReactGA.event({
                              category: "Installation page",
                              action: "Click filter control",
                              label: "Select all",
                            });
                          }}
                        >
                          {t("Select All")}
                        </div>
                        <div
                          className="right"
                          onClick={() => {
                            this.selectAll("clearAll");
                            ReactGA.event({
                              category: "Installation page",
                              action: "Click filter control",
                              label: "Clear",
                            });
                          }}
                        >
                          {t("Clear")}
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        SubjectMenuOpenState.indexOf("MobileMenu") != -1
                          ? "filter-box mobile open"
                          : "filter-box mobile"
                      }
                    >
                      {subjectsList.map((item, index) => {
                        return (
                          <div className={this.subMenuHandle(item)} key={index}>
                            <div className="item">
                              <label>
                                <input
                                  type="checkbox"
                                  name={item.englishSubjectName}
                                  id={item.subjectId}
                                  ref={(el) => {
                                    this[`${item.subjectId}`] = el;

                                    this.isAllBookSeriesSelectedUnderSubject(
                                      item.subjectId,
                                      item,
                                      "after"
                                    );
                                  }}
                                  checked={
                                    SubjectSelectedState.indexOf(
                                      item.subjectId
                                    ) == -1
                                      ? this.isAllBookSeriesSelectedUnderSubject(
                                          item.subjectId,
                                          item,
                                          "before"
                                        )
                                      : true
                                  }
                                  onChange={(e) =>
                                    this.onChangeSubjectCheckBox(e, item)
                                  }
                                />
                                {lang == "en-US" && item.englishSubjectName}
                                {lang == "zh-HK" && item.chineseSubjectName}
                                <div className="count">
                                  <div className="box">
                                    {this.countbookSeriesUnderSubject(item)}
                                  </div>
                                </div>
                              </label>
                              {SubjectMenuOpenState.indexOf(item.subjectId) ==
                              -1 ? (
                                <i
                                  className="material-icons"
                                  onClick={() => {
                                    this.openSubmenu(item.subjectId);
                                  }}
                                >
                                  keyboard_arrow_right
                                </i>
                              ) : (
                                <i
                                  className="material-icons"
                                  onClick={() => {
                                    this.openSubmenu(item.subjectId);
                                  }}
                                >
                                  keyboard_arrow_down
                                </i>
                              )}
                            </div>
                            {bookSeriesArray.map((bookSeries, sindex) => {
                              if (bookSeries.subject == item.subjectId)
                                return (
                                  <div className="sub-item" key={sindex}>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={
                                          SubjectSelectedState.indexOf(
                                            item.subjectId
                                          ) == -1
                                            ? selectedBookSeriesState.indexOf(
                                                bookSeries.shortName
                                              ) != -1
                                              ? true
                                              : false
                                            : true
                                        }
                                        //name={item.product.en}

                                        onChange={(e) =>
                                          this.onChangeBookSeriesCheckBox(
                                            e,
                                            bookSeries
                                          )
                                        }
                                      />

                                      {lang == "en-US" &&
                                        bookSeries.englishBookSeriesName}
                                      {lang == "zh-HK" &&
                                        bookSeries.chineseBookSeriesName}
                                    </label>
                                  </div>
                                );
                            })}
                          </div>
                        );
                      })}
                    </div>
                    <div
                      className={
                        SubjectMenuOpenState.indexOf("MobileMenu") != -1
                          ? "footer mobile open"
                          : "footer mobile"
                      }
                    />
                  </div>
                  <div className="card">
                    <div className="card-header card-header-divider-noborder aside-header">
                      <span className="pageTitle">
                        <img src={tool_icon} /> {t("Download Pearson Apps")}
                      </span>
                      <div className="sub-title">
                        <div>
                          {t(
                            "To access digital content via apps (best for tablet use), you can go to the"
                          )}{" "}
                          {t("App Store")} {t("or")} {t("Google play")}{" "}
                          {t("and install the following apps on your device.")}
                          
                        </div>
                        
                      </div>
                    </div>

                    <div className="card-body">
                      <div className="tools-list">
                        {toolsList.map((item, index) => {
                          var rend = false;
                          if (item.subject.length > 1) {
                            item.subject.map((subject) => {
                              if (SubjectSelectedState.indexOf(subject) != -1) {
                                rend = true;
                              }
                            });
                          } else {
                            if (
                              SubjectSelectedState.indexOf(item.subject[0]) !=
                              -1
                            ) {
                              rend = true;
                            }
                          }
                          if (rend == false) {
                            if (item.bookSeries.length > 1) {
                              item.bookSeries.map((bsitem) => {
                                if (
                                  selectedBookSeriesState.indexOf(bsitem) != -1
                                ) {
                                  rend = true;
                                }
                              });
                            } else {
                              if (
                                selectedBookSeriesState.indexOf(
                                  item.bookSeries[0]
                                ) != -1
                              ) {
                                rend = true;
                              }
                            }
                          }

                          if (rend)
                            return (
                              <div className="tool-box" key={index}>
                                <div className="tool-body">
                                  <div className="tool-icon">
                                    <img src={item.toolIconPath} />
                                  </div>
                                  <div className="tool-info">
                                    <div className="app-name">
                                      {lang == "en-US" && item.ToolName.en}
                                      {lang == "zh-HK" && item.ToolName.zh}
                                    </div>
                                    <div className="app-description">
                                      {lang == "en-US" &&
                                        item.toolDescription.en}
                                      {lang == "zh-HK" &&
                                        item.toolDescription.zh}
                                    </div>
                                    <div className="app-download">
                                      <div className="row-button">
                                        {item.toolId != "smartclass_t_pc" && (
                                          <a
                                            className="qr"
                                            onClick={() => {
                                              this.openModal("qrcode", item);

                                              ReactGA.event({
                                                category: "Installation page",
                                                action: "Open QR code pop up",
                                                label:
                                                  "App:" +
                                                  item.ToolName.en.replace(
                                                    "@",
                                                    " "
                                                  ) +
                                                  ", Book Series:[" +
                                                  item.bookSeries.join("|") +
                                                  "], Subject:[" +
                                                  item.subject.join("|") +
                                                  "]",
                                              });
                                            }}
                                          >
                                            <img src={qricon} />
                                          </a>
                                        )}
                                        {(item.androidApp.chineseURL &&
                                          item.androidApp.englishURL) != "" && (
                                          <a
                                            className="android"
                                            target="_blabk"
                                            href={
                                              lang == "en-US"
                                                ? item.androidApp.englishURL
                                                : item.androidApp.chineseURL
                                            }
                                            onClick={() => {
                                              ReactGA.event({
                                                category: "Installation page",
                                                action: "Download",
                                                label:
                                                  "App:" +
                                                  item.ToolName.en.replace(
                                                    "@",
                                                    " "
                                                  ) +
                                                  ", OS:Android, Book Series:[" +
                                                  item.bookSeries.join("|") +
                                                  "], Subject:[" +
                                                  item.subject.join("|") +
                                                  "]",
                                              });
                                            }}
                                          >
                                            <img src={androidicon} />
                                            Android
                                          </a>
                                        )}

                                        {(item.iosApp.chineseURL &&
                                          item.iosApp.englishURL) != "" && (
                                          <a
                                            className="ios"
                                            target="_blank"
                                            href={
                                              lang == "en-US"
                                                ? item.iosApp.englishURL
                                                : item.iosApp.chineseURL
                                            }
                                            onClick={() => {
                                              ReactGA.event({
                                                category: "Installation page",
                                                action: "Download",
                                                label:
                                                  "App:" +
                                                  item.ToolName.en.replace(
                                                    "@",
                                                    " "
                                                  ) +
                                                  ", OS:IOS, Book Series:[" +
                                                  item.bookSeries.join("|") +
                                                  "], Subject:[" +
                                                  item.subject.join("|") +
                                                  "]",
                                              });
                                            }}
                                          >
                                            <img src={iosicon} />
                                            iOS
                                          </a>
                                        )}
                                        {(item.web.chineseURL &&
                                          item.web.englishURL) != "" && (
                                          <a
                                            className="web"
                                            target="_blank"
                                            href={
                                              lang == "en-US"
                                                ? item.web.englishURL
                                                : item.web.chineseURL
                                            }
                                            onClick={() => {
                                              ReactGA.event({
                                                category: "Installation page",
                                                action: "Download",
                                                label:
                                                  "App:" +
                                                  item.ToolName.en.replace(
                                                    "@",
                                                    " "
                                                  ) +
                                                  ", OS:Web, Book Series:[" +
                                                  item.bookSeries.join("|") +
                                                  "], Subject:[" +
                                                  item.subject.join("|") +
                                                  "]",
                                              });
                                            }}
                                          >
                                            <img src={webicon} />
                                            Online
                                          </a>
                                        )}
                                        {(item.pc.chineseURL &&
                                          item.pc.englishURL) != "" && (
                                          <a
                                            className="pc"
                                            target="_blank"
                                            href={
                                              lang == "en-US"
                                                ? item.pc.englishURL
                                                : item.pc.chineseURL
                                            }
                                            onClick={() => {
                                              ReactGA.event({
                                                category: "Installation page",
                                                action: "Download",
                                                label:
                                                  "App:" +
                                                  item.ToolName.en.replace(
                                                    "@",
                                                    " "
                                                  ) +
                                                  ", OS:PC, Book Series:[" +
                                                  item.bookSeries.join("|") +
                                                  "], Subject:[" +
                                                  item.subject.join("|") +
                                                  "]",
                                              });
                                            }}
                                          >
                                            <img src={windosicon} />
                                            PC
                                          </a>
                                        )}
                                      </div>
                                    </div>
                                    <div className="app-requirement">
                                      <a
                                        onClick={() =>
                                          this.openModal("requirement", item)
                                        }
                                      >
                                        {t("System Requirements")}
                                        <img src={requirementicon} />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Modal
                isOpen={this.state.requirementModalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={() => this.closeModal("requirement")}
                style={customStyles}
                contentLabel="Example Modal"
                ariaHideApp={false}
              >
                <div className="modal-header modal-header-colored">
                  <h5 className="modal-title">
                    {item != null &&
                      (lang == "en-US"
                        ? item.ToolName.en
                        : item.ToolName.zh)}{" "}
                    - {t("Requriement")}
                  </h5>
                </div>
                <div className="modal-body">
                  {item != null &&
                    item.androidApp.englishURL != "" &&
                    item.androidApp.chineseURL &&
                    (lang == "en-US" ? (
                      <>
                        <span>
                          {t("System requirement for Android device")}
                        </span>
                        <ul>
                          {item.description.androidEnglishDes.map(
                            (item, index) => {
                              return <li key={index}>{item}</li>;
                            }
                          )}
                        </ul>
                      </>
                    ) : (
                      <>
                        <span>
                          {t("System requirement for Android device")}
                        </span>
                        <ul>
                          {item.description.androidChineseDes.map(
                            (item, index) => {
                              return <li key={index}>{item}</li>;
                            }
                          )}
                        </ul>
                      </>
                    ))}
                  {item != null &&
                    item.iosApp.englishURL != "" &&
                    item.iosApp.chineseURL != "" &&
                    (lang == "en-US" ? (
                      <>
                        <span>{t("System requirement for iOS device")}</span>
                        <ul>
                          {item.description.iosEnglishDes.map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      </>
                    ) : (
                      <>
                        <span>{t("System requirement for iOS device")}</span>
                        <ul>
                          {item.description.iosChineseDes.map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      </>
                    ))}
                  {item != null &&
                    item.web.englishURL != "" &&
                    item.web.chineseURL != "" &&
                    (lang == "en-US" ? (
                      <>
                        <span>{t("System requirement for Browser")}</span>
                        <ul>
                          {item.description.webEnglishDes.map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      </>
                    ) : (
                      <>
                        <span>{t("System requirement for Browser")}</span>
                        <ul>
                          {item.description.webChineseDes.map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      </>
                    ))}
                  {item != null &&
                    item.pc.englishURL != "" &&
                    item.pc.chineseURL != "" &&
                    (lang == "en-US" ? (
                      <>
                        <span>{t("System requirement for PC")}</span>
                        <ul>
                          {item.description.pcEnglishDes.map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      </>
                    ) : (
                      <>
                        <span>{t("System requirement for PC")}</span>
                        <ul>
                          {item.description.pcChineseDes.map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      </>
                    ))}
                </div>
                <div className="modal-footer">
                  <div className="modal-btn-left" />
                  <div className="modal-btn-right">
                    {" "}
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={() => this.closeModal("requirement")}
                    >
                      {t("Close")}
                    </button>
                  </div>
                </div>
                <button
                  type="button"
                  className="react-modal-close"
                  title="Close"
                  onClick={() => this.closeModal("requirement")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1"
                    viewBox="0 0 24 24"
                  >
                    <path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z" />
                  </svg>
                </button>
              </Modal>
              <Modal
                isOpen={this.state.qrcodeModalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={() => this.closeModal("qrcode")}
                style={customStyles}
                contentLabel="Example Modal"
                ariaHideApp={false}
              >
                <div className="modal-header modal-header-colored">
                  <h5 className="modal-title">
                    {item != null &&
                      (lang == "en-US"
                        ? item.ToolName.en
                        : item.ToolName.zh)}{" "}
                    - {t("QR Code")}
                  </h5>
                </div>
                <div className="modal-body">
                  <div className="qrCode">
                    {item != null &&
                      item.androidApp.toolAndroidQRPath != null &&
                      item.androidApp.toolAndroidQRPath != "" && (
                        <div className="android">
                          <img src={item.androidApp.toolAndroidQRPath} />
                          {(item.androidApp.chineseURL &&
                            item.androidApp.englishURL) != "" && (
                            <a
                              className="android"
                              target="_blabk"
                              href={
                                lang == "en-US"
                                  ? item.androidApp.englishURL
                                  : item.androidApp.chineseURL
                              }
                              onClick={() =>
                                ReactGA.event({
                                  category: "Installation page",
                                  action: "Click download in QR code",
                                  label:
                                    "App:" +
                                    item.ToolName.en.replace("@", " ") +
                                    ", OS:Android, Book Series:[" +
                                    item.bookSeries.join("|") +
                                    "], Subject:[" +
                                    item.subject.join("|") +
                                    "]",
                                })
                              }
                            >
                              <img src={androidicon} />
                              <div className="text">Android</div>
                            </a>
                          )}
                        </div>
                      )}
                    {item != null &&
                      item.iosApp.toolIosQRPath != null &&
                      item.iosApp.toolIosQRPath != "" && (
                        <div className="ios">
                          <img src={item.iosApp.toolIosQRPath} />
                          {(item.iosApp.chineseURL && item.iosApp.englishURL) !=
                            "" && (
                            <a
                              className="ios"
                              target="_blank"
                              href={
                                lang == "en-US"
                                  ? item.iosApp.englishURL
                                  : item.iosApp.chineseURL
                              }
                              onClick={() =>
                                ReactGA.event({
                                  category: "Installation page",
                                  action: "Click download in QR code",
                                  label:
                                    "App:" +
                                    item.ToolName.en.replace("@", " ") +
                                    ", OS:IOS, Book Series:[" +
                                    item.bookSeries.join("|") +
                                    "], Subject:[" +
                                    item.subject.join("|") +
                                    "]",
                                })
                              }
                            >
                              <img src={iosicon} />
                              iOS
                            </a>
                          )}
                        </div>
                      )}
                    {item != null &&
                      item.web.toolWebQRPath != null &&
                      item.web.toolWebQRPath != "" && (
                        <div className="web">
                          <img src={item.web.toolWebQRPath} />
                          {(item.web.chineseURL && item.web.englishURL) !=
                            "" && (
                            <a
                              className="web"
                              target="_blank"
                              href={
                                lang == "en-US"
                                  ? item.web.englishURL
                                  : item.web.chineseURL
                              }
                              onClick={() =>
                                ReactGA.event({
                                  category: "Installation page",
                                  action: "Click download in QR code",
                                  label:
                                    "App:" +
                                    item.ToolName.en.replace("@", " ") +
                                    ", OS:Web, Book Series:[" +
                                    item.bookSeries.join("|") +
                                    "], Subject:[" +
                                    item.subject.join("|") +
                                    "]",
                                })
                              }
                            >
                              <img src={webicon} />
                              Online
                            </a>
                          )}
                        </div>
                      )}
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="modal-btn-left" />
                  <div className="modal-btn-right">
                    {" "}
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={() => this.closeModal("qrcode")}
                    >
                      {t("Close")}
                    </button>
                  </div>
                </div>
                <button
                  type="button"
                  className="react-modal-close"
                  title="Close"
                  onClick={() => this.closeModal("qrcode")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1"
                    viewBox="0 0 24 24"
                  >
                    <path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z" />
                  </svg>
                </button>
              </Modal>
              <footer className="footer font-small blue">
                {localStorage.getItem("i18nextLng") == "en-US" ? (
                  <div className="footer-copyright text-center py-3">
                    <a
                      href="https://www.pearson.com.hk/en_GB/legal-notice.html"
                      target="_blank"
                    >
                      Legal Notice
                    </a>{" "}
                    |{" "}
                    <a
                      href="https://www.pearson.com.hk/en_GB/privacy-policy.html"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>{" "}
                    |{" "}
                    <a
                      href="https://www.pearson.com.hk/en_GB/personal-information-collection-statement.html"
                      target="_blank"
                    >
                      Personal Information Collection Statement
                    </a>{" "}
                    | © United Prime Educational Publishing (HK) Limited {footerYear}.
                    All rights reserved.
                  </div>
                ) : (
                  <div className="footer-copyright text-center py-3">
                    <a
                      href="https://www.pearson.com.hk/zh_HK/legal-notice.html"
                      target="_blank"
                    >
                      法律聲明
                    </a>{" "}
                    |{" "}
                    <a
                      href="https://www.pearson.com.hk/zh_HK/privacy-policy.html"
                      target="_blank"
                    >
                      私隱政策
                    </a>{" "}
                    |{" "}
                    <a
                      href="https://www.pearson.com.hk/zh_HK/personal-information-collection-statement.html"
                      target="_blank"
                    >
                      收集個人資料聲明
                    </a>{" "}
                    | © United Prime Educational Publishing (HK) Limited {footerYear}.
                    All rights reserved.
                  </div>
                )}
              </footer>
            </div>
          </div>
        </div>
      );
    }
    return <Loading />;
  }
}

export default InstallPage;
